import React, { useState, useEffect } from 'react';
import './MainEnSensor.css';
import { fetchEv_list } from '../../store';
import SunSensorIcon from '../../image/icons/solar-panel.png';
import SunTempIcon from '../../image/icons/high-temperature.png';
import { useSelector, useDispatch } from 'react-redux';

function SensorValue({ value, unit, className = '' }) {
  const displayValue =
    value === null || value === undefined || value === ''
      ? '--'
      : value;

  return (
    <span className={`ensensor-value ${className}`.trim()}>
      {displayValue}
      {unit && <span className="ensensor-unit">{unit}</span>}
    </span>
  );
}

function SensorRow({ label, value, unit, className }) {
  return (
    <div className="ensensor-row">
      <span className="ensensor-label">{label}</span>
      <SensorValue value={value} unit={unit} className={className} />
    </div>
  );
}

function MainEnSensor({ TopTitle }) {
  const dispatch = useDispatch();
  const Ev_list = useSelector((state) => state.Ev_list || {});
  const evData = useSelector((state) => state.evData || {});
  const [xsun, setXsun] = useState(0);
  const [ysun, setYsun] = useState(0);
  const [tempAir, setTempAir] = useState(0);
  const [tempSurface, setTempSurface] = useState(0);

  useEffect(() => {
    dispatch(fetchEv_list());
  }, [dispatch]);

  useEffect(() => {
    const seqLength = evData.seq?.length || 0;

    if (seqLength === 1) {
      const tempType = Ev_list.ev_temperatureType?.[0];
      const sunType = Ev_list.ev_sunType?.[0];

      if (sunType === 0) {
        setYsun(evData.sun[0] ?? 0);
      } else {
        setXsun(evData.sun[0] ?? 0);
      }

      if (tempType === 0) {
        setTempSurface(evData.temperature[0] ?? 0);
      } else {
        setTempAir(evData.temperature[0] ?? 0);
      }
    }

    if (seqLength === 2) {
      for (let i = 0; i < 2; i++) {
        const tempType = Ev_list.ev_temperatureType?.[i];
        const sunType = Ev_list.ev_sunType?.[i];

        if (sunType === 0) {
          setXsun(evData.sun[i] ?? 0);
        } else {
          setYsun(evData.sun[i] ?? 0);
        }

        if (tempType === 0) {
          setTempSurface(evData.temperature[i] ?? 0);
        } else {
          setTempAir(evData.temperature[i] ?? 0);
        }
      }
    }
  }, [evData, Ev_list]);

  const formatTemp = (value) => {
    const num = Number(value);
    if (!Number.isFinite(num)) return '0.0';
    return (num / 10).toFixed(1);
  };

  return (
    <section className="ensensor-card" aria-label="기상센서 환경 정보">
      <div className="gauge-panel-card-title" style={{ borderBottom: '2px solid #DCE0EB' }}>
        <div>◎ 기상 센서</div>
        <div style={{ flexGrow: '1' }}></div>
        <div style={{ marginLeft: '20px' }}>⦁ ⦁ ⦁</div>
      </div>

      <div className="ensensor-content">
        <div className="ensensor-section">
          <div className="ensensor-icon">
            <img src={SunSensorIcon} alt="일사량 센서" />
          </div>

          <div className="ensensor-readings">
            <SensorRow
              label="경사"
              value={xsun}
              unit="W/㎡"
              className="ensensor-value--sun"
            />
            <SensorRow
              label="수평"
              value={ysun}
              unit="W/㎡"
              className="ensensor-value--sun"
            />
          </div>
        </div>

        <div className="ensensor-divider" />

        <div className="ensensor-section">
          <div className="ensensor-icon">
            <img src={SunTempIcon} alt="온도 센서" />
          </div>

          <div className="ensensor-readings">
            <SensorRow
              label="표면"
              value={formatTemp(tempSurface)}
              unit="℃"
              className="ensensor-value--temp"
            />
            <SensorRow
              label="외기"
              value={formatTemp(tempAir)}
              unit="℃"
              className="ensensor-value--temp"
            />
          </div>
        </div>
      </div>
    </section>
  );
}

export default MainEnSensor;
